/** Appointment/Meeting utils */
import { trackKey } from "./Filter";
import { dateToKey } from "./Sort";
import {TRACK_HIDDEN} from '@/views/calendar/config';
import { htmlToText } from "./Text";

// ITEM(Appointment/Meeting) TYPES
// -------------------------------
// EACH LETTER MUST BE UNIQUE (Apart from D for deletion?)
//
// appointment.type = A...
// AT : Ticketed appointment
// S  : InSchedule / Pinned
//
// meeting.type = M...
// MP : Private
// MI : Inbound
// MO : Outbound
// M[I|O]C : Confirmed
//
// *
// ...D : Deleted
export const FLAGS = {
    APPOINTMENT: 'A',
    TICKETED: 'T', // Attendee has a ticket
    BOOKABLE: 'B', // Appointment is bookable (secondary to Attendee having a ticket)
    PINNED: 'S',
    TRACK_HIDDEN: 'H',

    MEETING: 'M',
    INBOUND: 'MI',
    OUTBOUND: 'MO',
    CONFIRMED: 'C',
    DELETED: 'D',
    PRIVATE: 'MP',
}


export const meetingPointName = (item, default_value) => {
    if (item.editable_meeting_point) {
        return item.editable_meeting_point;
    }
    if (item.meeting_point_name) {
        return item.meeting_point_name;
    }
    if (default_value) {
        return default_value;
    }
    return null;
}

/** Add timezone-aware date objects to Appointments/Meetings. 
 * 
*/
export const addDateObjects = (item, timezone) => {
    if (item.start_time_utc) {
        item.startObj = new Date(item.start_time_utc);
        item.startDateKey = dateToKey(item.startObj, timezone);
    }
    if (item.end_time_utc) {
        item.endObj = new Date(item.end_time_utc);
        item.endDateKey = dateToKey(item.endObj, timezone);
    }
    return item;
}


/** Add flags + trackKey to an appointment.
 * 
 */
export const addAppointmentFields = (appointment) => {
    appointment.flags = FLAGS.APPOINTMENT;
    if (Object.prototype.hasOwnProperty.call(appointment, 'appointment_attendees')) {
        appointment.flags += FLAGS.TICKETED;
    }
    if (appointment.bookable) {
        appointment.flags += FLAGS.BOOKABLE;
    }

    if (appointment.in_schedule) {
        appointment.flags += FLAGS.PINNED;
    }
    if (appointment.track_name === TRACK_HIDDEN) {
        appointment.flags += FLAGS.TRACK_HIDDEN;
    }

    appointment.uid = `a${appointment.id}`;
    appointment.abstract_text = htmlToText(appointment.abstract);
    appointment.trackKey = trackKey(appointment);
    return appointment;
};


/** Extend the meeting with 'other_' fields representing whichever of the 
 * meeting booker/attendee ISN'T the attendee passed in.
 * NOTE: We wrap the attendee object so that we can apply it when mapping a list of meetings
 * e.g. let copied = [...this.filtered].map(addOther(this.me));
 */
export const addOther = (attendee) => (meeting) => {
    if (meeting.attendee_organisation_id) {  // Ignore privates
        if (attendee.organisation_id == meeting.attendee_organisation_id) {
            // Attendee is from attendee_org, so use the Booker info
            meeting.other_id = meeting.booker_id
            meeting.other_name = meeting.booker_name;
            meeting.other_last_name = meeting.booker_name.split(' ').pop();
            meeting.other_organisation_name = meeting.booker_organisation_name;
            meeting.other_organisation_id =  meeting.booker_organisation_id;
            meeting.other_group_id =  meeting.booker_group_id;
            meeting.other_fields = meeting.booker_fields;
            meeting.flags = "MI"; // Inbound meeting
        } else {
            meeting.other_id = meeting.attendee_id
            meeting.other_name = meeting.attendee_name;
            meeting.other_last_name = meeting.attendee_name.split(' ').pop();
            meeting.other_organisation_name = meeting.attendee_organisation_name;
            meeting.other_organisation_id =  meeting.attendee_organisation_id;
            meeting.other_group_id =  meeting.attendee_group_id;
            meeting.other_fields = meeting.attendee_fields;
            meeting.flags = "MO"; // outbound meeting
        }
        if (meeting.confirmed_at) {
            meeting.flags = meeting.flags+"C";
        }
        if (meeting.deleted_at) {
            meeting.flags = meeting.flags+"D";
        }
    } else {
        meeting.flags = "MP";
    }
    
    meeting.uid = `m${meeting.id}`;
    return meeting;
}

